var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.idxArtpool < 3 && _vm.idxArtpool >=1)?[_c('NftPoolStakeV1',{attrs:{"idxArtpool":_vm.idxArtpool}})]:(_vm.idxArtpool >= 3)?[_c('NftPoolStakeV2',{attrs:{"idxArtpool":_vm.idxArtpool}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }